import { useSelector } from 'react-redux';
import { TrackReference } from '@livekit/components-react';
import { css, styled } from '@mui/material/styles';
import { selectLowerThirdsPercentage } from '../../../../redux/slices/room';
import { ParticipantTileMinimal } from '../../../LiveKit/ParticipantTileMinimal';
import { PipPosition, StreamType } from '../../enums';
import { useGetTracks } from '../../hooks';
import { useSetLiveView } from '../../hooks/useSetLiveView';
import { FullScreenVideoTrack } from '../../Styled';

interface IPipView {
  position: PipPosition;
  streamType: StreamType;
}

interface IPipVideoTrack {
  lowerThirdsHeight: number;
  position: PipPosition;
}

const PipVideoTrack = styled('div')<IPipVideoTrack>(
  ({ lowerThirdsHeight, position, theme }) => css`
    width: 20%;
    position: fixed !important;
    height: auto;
    max-height: 30%;
    right: ${theme.spacing(4)};
    top: ${position === 'top' ? theme.spacing(4) : 'auto'};
    bottom: ${position === 'bottom' ? `${32 + lowerThirdsHeight}px` : 'auto'};
    z-index: 1000;
  `,
);
export const PipView = ({ position, streamType }: IPipView) => {
  const lowerThirdsPercentage = useSelector(selectLowerThirdsPercentage);
  const lowerThirdsHeight = (window.innerHeight * lowerThirdsPercentage) / 100;
  const { tracks } = useGetTracks();
  const webcamTrack = tracks[StreamType.Webcam];
  const videoTrack = tracks[streamType];

  useSetLiveView({
    component: 'pipView',
    videoTracks: [webcamTrack],
  });

  if (!videoTrack) {
    return null;
  }
  return (
    <>
      <FullScreenVideoTrack
        height={`${100 - lowerThirdsPercentage}vh`}
        trackRef={videoTrack as TrackReference}
      />
      {webcamTrack ? (
        <PipVideoTrack
          lowerThirdsHeight={lowerThirdsHeight}
          position={position}
        >
          <ParticipantTileMinimal
            className="videoCam"
            trackRef={webcamTrack as TrackReference}
          />
        </PipVideoTrack>
      ) : null}
    </>
  );
};
